import type { PaymentPlanOption } from "./types";

/** Recovery is bound to its original plan by the Worker; show that plan alone. */
export const getCheckoutOfferPlans = (
  plans: PaymentPlanOption[],
  restoredPlanId?: string | null
): PaymentPlanOption[] => plans.filter((plan) =>
  restoredPlanId ? plan.id === restoredPlanId : plan.id === "weekly" || plan.id === "quarterly" || plan.id === "annual"
).sort((a, b) => {
  const order: Record<string, number> = { weekly: 0, monthly: 1, quarterly: 2, annual: 3 };
  return (order[a.id] ?? 99) - (order[b.id] ?? 99);
});

export const getDefaultCheckoutPlanId = (
  plans: PaymentPlanOption[],
  recommendedPlanId?: string | null
): string | null => (
  plans.find((plan) => plan.id === recommendedPlanId) ??
  plans.find((plan) => plan.id === "quarterly") ??
  plans.find((plan) => plan.isMostPopular) ??
  plans[0] ?? null
)?.id ?? null;
